import { render, staticRenderFns } from "./review-form.vue?vue&type=template&id=0223f2f2&scoped=true"
import script from "./review-form.vue?vue&type=script&lang=js"
export * from "./review-form.vue?vue&type=script&lang=js"
import style0 from "./review-form.vue?vue&type=style&index=0&id=0223f2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223f2f2",
  null
  
)

export default component.exports